<template>
  <teleport to="body">
    <div v-if="open" class="modal">
      <div class="product">
        <div class="content">
          <font-awesome-icon class="exit" icon="fa-xmark" @click="open = !open" />
          <div v-if="!currentAccount.new">
            <h3 class="title">Create Account</h3>
            <p class="line">
              <label class="half">Name</label>
              <input class="half" type="text" v-model="currentAccount.name" placeholder="Name" required />
            </p>
            <p class="line">
              <label class="half">ID</label>
              <input class="half" type="text" v-model="currentAccount.ID" placeholder="ID" required />
            </p>
            <p class="line">
              <label class="half">Balance</label>
              <input class="half" type="number" v-model="currentAccount.value" placeholder="0" />
            </p>
          </div>
          <div v-else>
            <span
              ><h3 class="title">Account: {{ currentAccount.name }}</h3>
            </span>
            <p>ID: {{ currentAccount.ID }}</p>
            <ul class="list">
              <li class="header">
                <span class="half">Date</span>
                <span class="quarter">Type</span>
                <span class="quarter">Value</span>
              </li>
              <li class="transactions" v-for="doc in orderedAccountTransactions" v-bind:key="doc">
                <span class="half">{{ new Date(doc.doc.date).toLocaleDateString() }}</span>
                <span class="quarter">{{ doc.doc.doc_type }}</span>
                <span class="quarter">{{ doc.doc.value }}</span>
              </li>
            </ul>
            <h3>Balance: <CurrencyFormatter :value="currentAccount.value" :currency="currency"/></h3>
          </div>
        </div>
        <div class="actions line">
          <div v-if="currentAccount.new" class="half">
            <label>Credit Amount:</label>
            <input class="half" type="number" v-model="creditAmount" placeholder="0" />
						<label>Add To Cart</label>
						<input type="checkbox" v-model="addToCart" />
          </div>
          <button v-if="currentAccount.new" class="action primary action-colour" @click.prevent.stop="credit">Add Credit</button>

          <button v-else class="action primary action-colour" @click.prevent.stop="commit">Save</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { mapGetters } from "vuex";
import { CurrencyFormatter } from "@monolith/components";

export default {
  name: "AccountModal",
  props: ["show", "account"],
  emits: ["save", "remove"],
  components: {CurrencyFormatter,},
  data() {
    return {
      open: false,
			addToCart: true,
			currentAccount: {},
      creditAmount: 0,
    };
  },
  methods: {
    remove() {
      this.open = !this.open;
      this.$emit("remove", this.currentAccount);
      this.open = false;
    },
    cancel() {
      this.open = !this.open;
    },
    commit() {
      let msg = "";
      let exists = null;
      if (this.accounts) {
        // check if there are any accounts to loop through
        const exists = this.accounts.map((account) => {
          return (
            account.key[1].toString().toLowerCase() === this.currentAccount.name.toLowerCase() || account.key[0].toString().toLowerCase() === this.currentAccount.ID.toLowerCase()
          );
        });
      }

      if (exists != null && exists.includes(true)) {
        msg = "Account with that Name or ID already exists";
      } else if (!this.currentAccount.name || !this.currentAccount.ID) {
        msg = "Please fill out Name and ID";
      } else if (!this.currentAccount.value) {
        msg = "Please enter a valid balance, it must be at least 0";
      } else {
        msg = "Account Saved";
        this.$emit("save", this.currentAccount);
        this.open = false;
      }

      let accountItem = {
        _id: "product:accounts" + this.currentAccount.ID,
        id: "product:accounts" + this.currentAccount.ID,
        modifiers: {},
        price: this.currentAccount.value,
        hash: "",
        name: "account-" + this.currentAccount.ID,
        value: {
          _id: "product:accounts" + this.currentAccount.ID,
          name: "product:accounts" + this.currentAccount.ID,
        },
      };
      this.$store.dispatch("addProduct", accountItem);
      this.$store.dispatch("addToCart", accountItem);

      // this.$notify({
      //   text: msg,
      //   type: msg === "Account Saved" ? "success" : "error",
      // });
    },
    credit() {
      if (typeof this.creditAmount !== "number") {
        this.$notify({
          text: "Please enter a credit amount",
          type: "error",
        });
        return;
      }
      let account = {
        _id: "product:accounts" + this.currentAccount.ID,
        id: "product:accounts" + this.currentAccount.ID,
        modifiers: {},
        price: this.creditAmount,
        hash: "",
        name: "account-" + this.currentAccount.ID,
        value: {
          _id: "product:accounts" + this.currentAccount.ID,
          name: "product:accounts" + this.currentAccount.ID,
        },
      };

      this.currentAccount.value = this.creditAmount;
      this.currentAccount.doc_type = "credit";
      this.currentAccount.date = new Date().toISOString();

			if (!this.addToCart) {
					this.$emit("save", this.currentAccount);
					this.open = false;
          this.channel.push("account:doc", this.currentAccount);
					return;
			}
      this.$store.dispatch("addProduct", account);
      this.$store.dispatch("addToCart", account);
      this.$emit("save", this.currentAccount);
      this.open = false;
			this.$notify({
         text: "Account added to cart.",
         type: "success",
       });
    },
  },
  watch: {
    show() {
      this.open = true;
    },
    account() {
      this.currentAccount = this.account;
    },
  },
  computed: {
    ...mapGetters({
      curAccount: "curAccount",
      accounts: "accounts",
      currency: "currency"
    }),

    orderedAccountTransactions() {
      let ordersArray = [];
      if (Object.keys(this.curAccount).length <= 1) {
        return this.curAccount;
      } else {
        for (let transaction of this.curAccount) {
          ordersArray.push(transaction);
        }
        return ordersArray.sort((a, b) => new Date(b.doc.date) - new Date(a.doc.date));
      }
    },
  },
};
</script>

<style lang="scss">
@use "@monolith/styles";

.modal {
  z-index: 1111;
}

.line {
  display: flex;
  .half {
    flex: 1;
    font-size: large;
    text-align: center;
		label {
				margin: 1rem;
		}
    input {
      box-shadow: var(--box-shadow);
      border-radius: 0.25rem;
      margin-left: 1rem;
      border: none;
    }
  }
}

.list {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  .header {
    display: flex;
    flex: 1 100%;
  }
  .half {
    flex: 2;
  }
  .quarter {
    flex: 1;
  }
  .transactions {
    display: flex;
    flex: 1 100%;
  }
}

@media only screen and (orientation: portrait) {
  .actions {
    .half {
      input {
        margin-left: 0;
        margin-right: 1rem;
      }
    }
  }
  .line {
    .half {
      border-radius: 5px;
    }
  }
}
</style>
